/* @flow */
import Products, { type ProductType } from 'common/enums/Product';

class ProductTrackerService {
    activeProduct: ?ProductType;

    setActiveProduct(product: ProductType): void {
        this.activeProduct = product;
    }

    getActiveProduct(): ProductType {
        return this.activeProduct || this.getDefaultTeam();
    }

    getDefaultTeam(): ProductType {
        return Products.PLATFORM;
    }
}

export default new ProductTrackerService();
